import { render, staticRenderFns } from "./staff-list-form.vue?vue&type=template&id=1a0be993&"
import script from "./staff-list-form.vue?vue&type=script&lang=js&"
export * from "./staff-list-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports